import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { Box, Centered, FaSvg, Asset, themeUtils } from '@zen-common/components-base';
import { assetUtils } from '@zen/common-utils';

const { color, space, fontSize, mq } = themeUtils;

/**
 * Order book search view mode
 */
export default function ViewMode({ base, quote, onSearch, naming }) {
  const displayName = (hash) =>
    naming && naming[hash] ? naming[hash].shortName : assetUtils.truncateOrNameAsset(hash);
  return (
    <ViewModeBox onClick={onSearch} data-testid="edit-base-quote">
      <Asset hash={base} displayName={displayName(base)} />
      <ViewModeAssetsSeparator>/</ViewModeAssetsSeparator>
      <Asset hash={quote} displayName={displayName(quote)} />
      <Centered ml={['xxs', null, 'sm']}>
        <FaSvg icon={faChevronDown} color="label" />
      </Centered>
    </ViewModeBox>
  );
}
ViewMode.propTypes = {
  base: PropTypes.string,
  quote: PropTypes.string,
  onSearch: PropTypes.func,
};

const ViewModeBox = styled(Box)`
  font-weight: 500;
  border-color: ${color('bg')} !important;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background-color: ${color('bg4')};
    opacity: 0.7;
  }
  ${css(
    mq({
      borderRight: ['0', null, '1px'],
      borderBottom: ['1px', null, '0'],
      fontSize: [fontSize('lg'), fontSize('xl'), fontSize('xxl')],
    })
  )}
`;
const ViewModeAssetsSeparator = styled.span`
  display: inline-block;
  margin: 0 ${space('xs')};
`;
